import { CommonService } from "../../Services/common.service";
import { AuthService } from "../../Services/auth.service";
import { ErrorLoggingService } from "../../Services/error-logging.service";
import { TranslateService } from "@ngx-translate/core";

import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, from, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import {
  switchMap,
  map,
  retry,
  retryWhen,
  mergeMap,
  delay,
} from "rxjs/operators";
import { HttpServiceService } from "../../Services/http-service.service";
import { VerifyServerCertificateService } from './verify-server-certificate.service'; 

// import { debugOutputAstAsTypeScript } from "@angular/compiler";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { CookieService } from '../../Services/cookie';
import { ConfigService } from "../../Services/config.service";


@Injectable({
  providedIn: "root",
})
export class BaseClassService implements HttpInterceptor {
  modalObservable: Subject<void> = new Subject<void>();

  platform: string = "w";
  longitude;
  latitiude;
  idleTimer: any;
  private _jsonURL = "assets/APIURL.json";
  private readonly IDLE_DURATION = 60000; // 1 minute in milliseconds

  ReferralCode: any;

  constructor(
    private injector: Injector,
    private auth: AuthService,
    private commonService: CommonService,
    private cookieService:CookieService,
    private http: HttpServiceService,
    private _router :Router,
    private translate: TranslateService,
    private config : ConfigService,
    private certificate:VerifyServerCertificateService,
    private errorLogging: ErrorLoggingService
  ) {
    this.startIdleTimer();

    // this.getlocationservice().then((resp) => {
    //   this.longitude = JSON.stringify(resp.lng);
    //   this.latitiude = JSON.stringify(resp.lat);

    // });
    this.getCode();
  }

  async getCode() {
    this.ReferralCode = await this.commonService.Get("ReferalCode");
  }
  // getlocationservice(): Promise<any> {
  //   return new Promise((resolve, rejects) => {
  //     navigator.geolocation.getCurrentPosition((resp) => {
  //       resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
  //     });
  //   });
  // }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let http: HttpClient = this.injector.get(HttpClient);
 console.log("Interceptor triggered:", req.url);
    // ============================================================
    // DIAGNOSTIC — see LOYALTY_POINTS_RADEEM_401_ISSUE.md
    // ============================================================
    console.log('[Interceptor] IN', {
      method: req.method,
      url: req.url,
      hasBody: !!req.body,
      authHeader: req.headers.get('Authorization')?.substring(0, 20),
    });
    if (req.url.includes("undefined")) {

      
      clearTimeout(this.idleTimer);
      this.startIdleTimer();


      return http.get(this._jsonURL).pipe(
        switchMap((response: any) => {
          
          let a = req.url;
          a = a.replace("undefined", response.URL);
             console.log("Loaded API URL:", response.URL);
    console.log("Final Request URL:", a);
          const newUrl = { url: a };
          const urlWithParams = { urlWithParams: a };
          req = Object.assign(req, newUrl);
          req = Object.assign(req, urlWithParams);
          
          // const serverCertificate = '../../../certificate/certificate_publickey.pem'

// Comment once  kashif bhai return Certificate than i will reopen this and check (certificate will provide by shahrukh)






          // if (serverCertificate && this.certificate.verifyServerCertificate(serverCertificate)) {
          //   
          //   if (req.method == "POST") {
          //     
          //     let a = req.body;
  
          //     let b = JSON.parse(a);
          //       
          //       b.baseClass = {
          //         ip: "",
          //         deviceID: this.auth.deviceid ? this.auth.deviceid :"string",
          //         channelType: "Web",
          //         latitude: "",
          //         longitude: "",
          //         platform: "W",
          //         browser: "string",
          //         mobileModel: "string",
          //         appVersion: "0.0.1",
          //       };
          
          //     return from(this.commonService.FinalEncrypt(b)).pipe(
          //       switchMap((data) => {
  
          //         // data = {
          //         //   data: "FErVg6GmJWVqOS1AGtj5v1y5/iPICnlR6VRIK9FKBGt5cTY3h6Ga4+opSd3ObqM4yDVvNwnGCuEaOmmeiw36d8KM0IqRLL+6h3ZcfBo5yzzpQVWQk2fZ6sjjpAyR26VPsThMrLHTDZSsiofdZ5tiIqpoAX1HkKDHIdS9Vls15VBF8hyr2MiZvahfwdtHt+mDz2C00b7tJ8nWcJJn46Jz9SUhNTldX9FluuXgOl8wov6GG5Ozt+XR54F4NCKHIGl0wXd6qHwh/UrKrL4GC2NcWIGCGu3U8h9QrA1ez6/hSfWrpZkTK/NYZeo4om8IjZ22OHklFHhLeIzzbN2di7bwyg==",
  
          //         //   data1:
          //         //     "jO5k8YsRLnYyIBAaSES/9PZ4T7E3K+MIKvRLsfQQAQ/MKMwKlDrGPPVOvq4l5tO4g9v7Gh9GP/Sh0FSncxTOrWtyzNLxTgJgLUgW0KtOsPj2z6wFME6IZ50pvnoLAMQJklv/39HhrfgKRbCs5WWKql6WiW+w2SEmJrX/oEqs4SKrheNnEo7k41jotwjObwE8ZY1V+7kN7DfS6sFYwIOwQ1fu18zp5JWXLUL0I5WQ/pHng6VGM31mBEUiUwTO1/r37JG1SrvSnNoivorkVaT32DbuJXa/I+w8/TVkp1p1qdMnKQw46sF+Hmls7xoTJ62sstbQS/BaB+EJFZtNr9b17P6G63vmSlr9vzWTXBHKg4IqK/WyC40F42UT2+S1oTgaYZi2MxOzqycaa09x4gajj1gIaybGpx3OXG151SKfFhfYosUN4hMH6Wy4VeCvrlDhQwPoC4GcWmkVGgr0hfboy8oSlw5whNVesGO6DQ1PEmb2Dzg+70TXzJdi/JwQmM2043KLE7KHytO/CcAWB+vuIRYoSDZ4E4E9I+DBKfYrB+XVT7ae/r34ajJZzXOQDg8+YmZVz3Cm2zvnh4OoluFIqpznf83/02qIu9bIt3G/76DsbaIeooU+DZe6VPbWDQxS8mCVvc6KaLr0IjvJUUm8/mNlNSLsRtL9zzeaUv078Q==",
          //         // };
  
          //         const bod = { body: data };
          //         req = Object.assign(req, bod);
  
  
          //         return next.handle(req).pipe(
          //           retryWhen((error) => {
          //             return error.pipe(
          //               mergeMap(async (error, index) => {
          //                 if (index < 3 && error?.error?.code == 110) {
          //                   let data = await this.commonService.FinalEncrypt(b);
          //                   const bod = { body: data };
          //                   req = Object.assign(req, bod);
          //                   return of(error).pipe(delay(3000));
          //                 }
  
          //                 throw error;
          //               })
          //             );
          //           }),
          //           map((event: HttpEvent<any>) => {
          //             if (event instanceof HttpResponse) {
          //               if (event.body?.response?.token) {
          //                 
          //                 this.auth.accessToken = event.body?.response?.token;
          //                 this.commonService.Set("token", this.auth.accessToken);
          //                 console.log('token',this.auth.accessToken)
          //               }
          //               if (event.body?.response?.content) {
          //                 
          //                 if(this.auth.deviceid=="" || this.auth.deviceid==undefined){
          //                   this.auth.deviceid = event.body?.response?.content?.l?.webdeviceId;
          //                   if(event.body?.response?.content?.webdeviceId){
          //                     this.auth.deviceid = event.body?.response?.content?.webdeviceId;
          //                   }
          //                 }
          //                 if(this.auth.tokenTimeOut==0 || this.auth.tokenTimeOut==undefined){
          //                   this.auth.tokenTimeOut = event.body?.response?.content?.tokenTimeOut;
          //                   if(event.body?.response?.content?.tokenTimeOut){
          //                     this.auth.tokenTimeOut = event.body?.response?.content?.tokenTimeOut;
          //                   }
  
          //                 }
          //                 console.log('deviceid',this.auth.deviceid)
          //                 console.log('tokenTimeOut',this.auth.tokenTimeOut)
  
          //               }
          //             }
  
          //             return event;
          //           })
          //         );
          //       })
          //     );
          //   } else {
          //     
  
          //     return next.handle(req).pipe(
          //       map((event: HttpEvent<any>) => {
          //         if (event instanceof HttpResponse) {
          //           
  
          //           if (event.body?.response?.token) {
          //             this.auth.accessToken = event.body?.response?.token;
          //             this.commonService.Set("token", this.auth.accessToken);
          //           }
          //           if (event.body?.response?.content) {
          //             
          //             if(this.auth.deviceid=="" || this.auth.deviceid==undefined){
          //               this.auth.deviceid = event.body?.response?.content?.l?.webdeviceId;
                    
          //             }
          //             console.log('deviceid',this.auth.deviceid)
          //           }
          //         }
          //         return event;
          //       })
          //     );
          //   }
          // } else {
          //   
          //   // Handle invalid server certificate
          //   // ...
          //   console.log('certificate not matched....');
          // }
         

          if (req.method == "POST") {
             
            
            let a = req.body;
        
            let b = JSON.parse(a);

          this.auth.deviceid= this.cookieService.get("deviceid",false);

              
              b.baseClass = {
                ip: "",
                deviceID: this.auth.deviceid ? this.auth.deviceid :"string",
                channelType: "Web",
                latitude: "",
                longitude: "",
                platform: "W",
                browser: "",
                mobileModel: "",
                appVersion: "",
              };
              console.log('request',b);

            // ===== API ENCRYPTION — exactly like mobile =====
            // Mobile (data/lib/network/api_interceptor.dart) disables encryption by
            // commenting ONE line:
            //   options.data = _encryptRequest(options.data);   // comment out => plaintext
            // Same single-line toggle here: `bodyToSend` defaults to the raw
            // plaintext body, and the line below reassigns it to the encrypted
            // { data, data1 }. To send PLAINTEXT (encryption OFF for cyber / VAPT
            // testing) just comment out that one line and rebuild.
            let bodyToSend: Promise<any> = Promise.resolve(b);
            // bodyToSend = this.commonService.FinalEncrypt(b);   // <-- comment this line to disable encryption

            return from(bodyToSend).pipe(
              switchMap((data) => {
        
                // data = {
                //   data: "FErVg6GmJWVqOS1AGtj5v1y5/iPICnlR6VRIK9FKBGt5cTY3h6Ga4+opSd3ObqM4yDVvNwnGCuEaOmmeiw36d8KM0IqRLL+6h3ZcfBo5yzzpQVWQk2fZ6sjjpAyR26VPsThMrLHTDZSsiofdZ5tiIqpoAX1HkKDHIdS9Vls15VBF8hyr2MiZvahfwdtHt+mDz2C00b7tJ8nWcJJn46Jz9SUhNTldX9FluuXgOl8wov6GG5Ozt+XR54F4NCKHIGl0wXd6qHwh/UrKrL4GC2NcWIGCGu3U8h9QrA1ez6/hSfWrpZkTK/NYZeo4om8IjZ22OHklFHhLeIzzbN2di7bwyg==",
        
                //   data1:
                //     "jO5k8YsRLnYyIBAaSES/9PZ4T7E3K+MIKvRLsfQQAQ/MKMwKlDrGPPVOvq4l5tO4g9v7Gh9GP/Sh0FSncxTOrWtyzNLxTgJgLUgW0KtOsPj2z6wFME6IZ50pvnoLAMQJklv/39HhrfgKRbCs5WWKql6WiW+w2SEmJrX/oEqs4SKrheNnEo7k41jotwjObwE8ZY1V+7kN7DfS6sFYwIOwQ1fu18zp5JWXLUL0I5WQ/pHng6VGM31mBEUiUwTO1/r37JG1SrvSnNoivorkVaT32DbuJXa/I+w8/TVkp1p1qdMnKQw46sF+Hmls7xoTJ62sstbQS/BaB+EJFZtNr9b17P6G63vmSlr9vzWTXBHKg4IqK/WyC40F42UT2+S1oTgaYZi2MxOzqycaa09x4gajj1gIaybGpx3OXG151SKfFhfYosUN4hMH6Wy4VeCvrlDhQwPoC4GcWmkVGgr0hfboy8oSlw5whNVesGO6DQ1PEmb2Dzg+70TXzJdi/JwQmM2043KLE7KHytO/CcAWB+vuIRYoSDZ4E4E9I+DBKfYrB+XVT7ae/r34ajJZzXOQDg8+YmZVz3Cm2zvnh4OoluFIqpznf83/02qIu9bIt3G/76DsbaIeooU+DZe6VPbWDQxS8mCVvc6KaLr0IjvJUUm8/mNlNSLsRtL9zzeaUv078Q==",
                // };
        
                const bod = { body: data };
                req = Object.assign(req, bod);
        console.log('request',req);
    return next.handle(req).pipe(
                  retryWhen((error) => {

                    return error.pipe(
                      mergeMap(async (error, index) => {

                          console.log("RealError",error);
                        console.log("Key errror");
                        console.log(index);
                        console.log(error?.error?.code);
                        // ============================================================
                        // DIAGNOSTIC — see LOYALTY_POINTS_RADEEM_401_ISSUE.md
                        // ============================================================
                        console.log('[Interceptor] HTTP ERROR', {
                          attempt: index + 1,
                          status: error?.status,
                          bodyCode: error?.error?.Code ?? error?.error?.code,
                          bodyMessage: error?.error?.Message ?? error?.error?.message,
                          bodyContent: error?.error?.Content ?? error?.error?.content,
                          hasNewTokenInError: !!error?.error?.response?.token,
                          rawBody: error?.error,
                        });
                        
                        // if (index < 3 && error?.error?.code == 110) {
                        //   let data = await this.commonService.FinalEncrypt(b);
                        //   const bod = { body: data };
                        //   req = Object.assign(req, bod);
                        //   return of(error).pipe(delay(3000));

                        // }
                        // if (index < 3 && error?.error?.message == "Unable to decrypt aes key") {

                        //   let data = await this.commonService.FinalEncrypt(b);
                        //   const bod = { body: data };
                        //   req = Object.assign(req, bod);
                        //   return of(error).pipe(delay(3000));
                        //
                        // }
                        // if (index < 3 && error?.error?.message?.includes("Unable  to decrypt aes key") || error?.error?.message?.includes("Unable  to decrypt aes key") ) 
                        if (
                          index < 3 &&
                          (error?.error?.message?.includes("Unable to decrypt aes key") ||
                           error?.error?.message === "Unable  to decrypt aes key")
                      )
                          {
                          

                          let data = await this.commonService.FinalEncrypt(b);
                          const bod = { body: data };
                          req = Object.assign(req, bod);
                          return of(error).pipe(delay(3000));
                          //
                      }
                        
                      else if(error?.error != null && error?.error?.response?.token != ""){

                          console.log("error not null or empty");
                          if(error?.error?.response?.token){
                            this.auth.accessToken = error?.error?.response?.token;
                          this.commonService.Set("token", this.auth.accessToken);
                          }
                          

                        }
        
                        // Log to Sahel backend before rethrowing
                        this.errorLogging.captureHttpError(error, "BaseClassInterceptor");
                        throw error;
                      })
                    );
                  }),
                  map((event: HttpEvent<any>) => {
                    console.log("eventdata22",event);

                    if (event instanceof HttpResponse) {
                      // ============================================================
                      // DIAGNOSTIC — see LOYALTY_POINTS_RADEEM_401_ISSUE.md
                      // ============================================================
                      console.log('[Interceptor] HTTP RESPONSE', {
                        url: event.url,
                        status: event.status,
                        hasResponse: !!event.body?.response,
                        responseCode: event.body?.response?.code,
                        hasNewToken: !!event.body?.response?.token,
                        newTokenLength: event.body?.response?.token?.length,
                        newTokenPrefix: event.body?.response?.token?.substring(0, 12),
                      });

                      if (event.body?.response?.token) {

                        this.auth.accessToken = event.body?.response?.token;

                        this.commonService.Set("token", this.auth.accessToken);

                        console.log('[Interceptor] TOKEN ROTATED', {
                          newLength: this.auth.accessToken?.length,
                          newPrefix: this.auth.accessToken?.substring(0, 12),
                        });
                      }
                      if (event.body?.response?.content) {

                          // if((this.auth.deviceid=="" || this.auth.deviceid==undefined) &&
                          if (event.body?.response?.content?.l != undefined){

                            
                            this.auth.deviceid = event.body?.response?.content?.l?.webdeviceId;
                            if(this.auth.deviceid){

                              this.auth.deviceid =this.auth.deviceid;
                              // let key = this.cookieService.generateKey();
                              this.cookieService.set("deviceid",this.auth.deviceid,false);
                            }

                          }
                          
                                          
                        if(this.auth.tokenTimeOut==0 || this.auth.tokenTimeOut==undefined){

                          this.auth.tokenTimeOut = event.body?.response?.content?.tokenTimeOut;
                          

                          
                          if(event.body?.response?.content?.tokenTimeOut){
                            
                            this.auth.tokenTimeOut = event.body?.response?.content?.tokenTimeOut;
                            
                          }
                          else{
                            
                            this.auth.tokenTimeOut = this.config.TimeOut;

                          }

                        }
                        console.log('deviceid',this.auth.deviceid)
                        console.log('tokenTimeOut1',this.auth.tokenTimeOut)

                      }
                    }

                    return event;
                  })
                );
              })
            );
          } else {

            
            return next.handle(req).pipe(
              map((event: HttpEvent<any>) => {
                
                if (event instanceof HttpResponse) {


                  if (event.body?.response?.token) {

                    this.auth.accessToken = event.body?.response?.token;
                    
                    this.commonService.Set("token", this.auth.accessToken);
                  }
                  if (event.body?.response?.content) {

                    if(this.auth.deviceid=="" || this.auth.deviceid==undefined){
                      this.auth.deviceid = event.body?.response?.content?.l?.webdeviceId;
                  
                    }
                    console.log('deviceid',this.auth.deviceid)
                  }
                }
                return event;
              })
            );
          }
        })
      );
    }
    return next.handle(req);
  }
  // private startIdleTimer(): void {
  //   if(this.auth.tokenTimeOut!==0 &&this.auth.tokenTimeOut!==undefined && this.auth.accessToken!==''){
  //     this.idleTimer = setTimeout(() => {
  //       // This code will execute after the idle duration
  //       // console.log('No API calls made during the 1-minute interval.');
  //       // this.commonService.showSuccessToast('Session Expire','session expire');
  //       this.translate.get(["Yes", "No", "Yoursessionisabout"]).subscribe(async (data) => {
  //         this.commonService.showTwoButtonAlert("Refresh Token", data["Yoursessionisabout"], [data["No"], data["Yes"]], this._router).then(async (data: any) => {
            
  //           if (data == "Yes") {
  //             this.auth.accessToken = await this.commonService.Get("token");
  //             await this.commonService.presentLoading();
          
  //             this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {  
  //               if (data.response) {
  //                 if (data.response.code) {
  //                   if (data.response.code == 1) {
  //                     let key = this.cookieService.generateKey();
  //                     this.cookieService.set("detailuser",JSON.stringify(data.response.content.allowedServices),false,key)
  //                     this.commonService.hideLoading();
  
                    
          
  //                   } else {
  //                     await this.commonService.hideLoading();
  //                     this.commonService.ParseErrorAlert("", "", this._router, data);
  //                   }
  //                 } else {
  //                   await this.commonService.hideLoading();
  //                   this.commonService.ParseErrorAlert("", "", this._router, data);
  //                 }
  //               } else {
  //                 await this.commonService.hideLoading();
  //                 this.commonService.ParseErrorAlert("", "", this._router, data);
  //               }
  //             });
  
  
  //           }
  //           else {
  //             this.commonService.clear();
  //             this.commonService.clearLogout();
  //             this.auth.tokenTimeOut=0;
  //             this._router.navigateByUrl("/LoginWithIdNum");
  //           }
  //         })
  //       })
  
  //     }, this.auth.tokenTimeOut);
  //   }
    
  // }


// working but with hard reload

  private startIdleTimer(): void {
    console.log("yaha agaya");
    console.log("Token Timeout:", this.auth.tokenTimeOut);
    console.log("Access Token:", this.auth.accessToken);
    if (this.auth.tokenTimeOut !== 0 && this.auth.tokenTimeOut !== undefined && this.auth.accessToken !== '') {
      console.log("margaya yaha");
        // const showPopupTime = this.auth.tokenTimeOut - (19 * 60 * 1000); //19 minutes
        const showPopupTime = this.auth.tokenTimeOut - 60000; // 1 min in token expiry

        this.idleTimer = setTimeout(() => {
            // This code will execute 19 minutes before session expiration
            this.translate.get(["Yes", "No", "Yoursessionisabout"]).subscribe(async (data) => {
                this.commonService.showTwoButtonAlert("Refresh Token", data["Yoursessionisabout"], [data["No"], data["Yes"]], this._router).then(async (data: any) => {
                    if (data === "Yes") {

                        this.auth.accessToken = await this.commonService.Get("token");
                        await this.commonService.presentLoading();

                        this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
                            if (data.response) {
                                if (data.response.code) {
                                    if (data.response.code === 1) {
                                      this.auth.detailuser = data?.response?.content;
                                        // let key = this.cookieService.generateKey();
                                        // this.cookieService.set("detailuser", JSON.stringify(data.response.content.allowedServices), false, key);
                                        this.commonService.hideLoading();
                                    } else {
                                        await this.commonService.hideLoading();
                                        this.commonService.ParseErrorAlert("", "", this._router, data);
                                    }
                                } else {
                                    await this.commonService.hideLoading();
                                    this.commonService.ParseErrorAlert("", "", this._router, data);
                                }
                            } else {
                                await this.commonService.hideLoading();
                                this.commonService.ParseErrorAlert("", "", this._router, data);
                            }
                        });
                    } else {
                      this.auth.detailuser = null
                        this.commonService.clear();
                        this.commonService.clearLogout();
                        this.auth.tokenTimeOut = 0;
                        this._router.navigateByUrl("/LoginWithIdNum");
                    }
                });
            });
        }, showPopupTime);
    }
    else{
      console.log("khatam bye");
      
    }
}



}
